/** Trimmed + lowercased, for comparing two email addresses. */
export const normalizeEmail = (value?: string | null): string =>
  (value ?? '').trim().toLowerCase()

/** Digits only. */
export const normalizePhone = (value?: string | null): string =>
  (value ?? '').replace(/\D/g, '')

/**
 * A key for deciding whether two phone numbers are the same person.
 *
 * Uses the last 9 digits so that a local '01098765432' and an international
 * '+20 109 876 5432' collapse to the same key — stripping a leading zero is not
 * enough, since the country code is a prefix rather than a leading zero. This
 * is single-country (Egypt) reasoning and is only ever used for advisory
 * duplicate detection, never as an identity.
 */
export const phoneMatchKey = (value?: string | null): string =>
  normalizePhone(value).slice(-9)

export const isValidEmail = (value: string): boolean =>
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim())

/** Deliberately permissive: local and international formats both reach here. */
export const isValidPhone = (value: string): boolean =>
  normalizePhone(value).length >= 8
